import { Box, Container, Typography } from "@mui/material";
import { Lock as LockIcon, Shield as ShieldIcon } from "@mui/icons-material";

const PaymentFooter = () => {
	return (
		<Box
			component="footer"
			sx={{
				py: 2,
				px: 3,
				mt: 4,
				backgroundColor: "background.paper",
				borderTop: "1px solid",
				borderColor: "divider",
			}}
		>
			<Container maxWidth="lg">
				<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
					<Box sx={{ display: "flex", alignItems: "center" }}>
						<ShieldIcon sx={{ mr: 1, fontSize: 20, color: "text.secondary" }} />
						<LockIcon sx={{ mr: 1, fontSize: 20, color: "text.secondary" }} />
						<Typography variant="body2" color="text.secondary">
							Pagamento 100% Seguro
						</Typography>
					</Box>
					<Typography variant="body2" color="text.secondary">
						Ao realizar o pagamento, você concorda com nossos{" "}
						<Box component="span" sx={{ color: "primary.main", cursor: "pointer" }}>
							Termos e Condições
						</Box>
					</Typography>
				</Box>
			</Container>
		</Box>
	);
};

export default PaymentFooter;
